module.exports = __webpack_public_path__ + "media/images/banner06-3a61151fb5169621d878ae5b9daceace.jpg";